import React, { FC } from 'react';
import { HeaderBar } from '@app/common/PageHeader/HeaderBar';
import { observer } from 'base/store';
import { StickyHeader } from '@base/lib/StickyHeader';
import { IHeaderLogoProps } from '@pro/common/HeaderLogo';

export type IPageHeaderProps = {
    headerProps?: {
        logoType?:  IHeaderLogoProps['type'];
        className?: string;
    }
}

const PageHeader: FC<IPageHeaderProps> = props => {
    const { headerProps } = props;

    return (
        <StickyHeader>
            <HeaderBar {...headerProps}/>
        </StickyHeader>
    );
}

export default observer(PageHeader);
